
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR' // Indicate an error when logging in
export const SET_SIGNUP_ERROR = 'SET_SIGNUP_ERROR' // Indicate an error when signing in
export const SET_RECOVER_PASSWORD_ERROR = 'SET_RECOVER_PASSWORD_ERROR' // Indicate an error during password recovery 
export const SET_SIGNOUT_ERROR = 'SET_SIGNOUT_ERROR' // Indicate an error when signing out
export const SET_USER = 'SET_USER';   // Set authenticated user
export const SET_CURRENT_CLIP = 'SET_CURRENT_CLIP' // Set current audio clip
export const SET_TIMELINE_POSTS = 'SET_TIMELINE_POSTS' // Get List of posts for the user timeline
